import styled from 'styled-components';
import { ColorAddiCompFiveBase, ColorAddiCompFiveLighten4, ColorAddiGrayBase, ColorAddiGrayLighten3, ColorAddiBackgroundSoft, ColorAddiWhite } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { Label } from '../typographies';
export const Container = styled.div `
    border-width: 0;
`;
export const InputLabel = styled(Label) `
    cursor: default;
    position: relative;
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    font-size: ${SizeAddiFontXSmall};

    &::after {
        content: '';
        width: 44px;
        height: 44px;
        background: ${ColorAddiCompFiveLighten4};
        border-radius: 50%;
        position: absolute;
        z-index: 0;
        top: -8px;
        left: -9px;
        visibility: hidden;
    }

    &:hover {
        &::after {
            visibility: visible;
        }
    }
`;
export const Input = styled.input `
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid ${ColorAddiGrayBase};
    border-radius: 2px;
    margin-right: 12px;
    position: relative;
    z-index: 100;
    
    &:hover {}
    &:focus {
        outline: none;
    }

    &:checked {
        background: ${ColorAddiCompFiveBase};
        border-color: ${ColorAddiCompFiveBase};

        &::after {
            visibility: visible;
        }
    }

    &:disabled {
        background: ${ColorAddiBackgroundSoft};
        border-color: ${ColorAddiBackgroundSoft};

        &::after {
            border-color: ${ColorAddiGrayLighten3};
        }
    }

    &::after {
        content: "";
        visibility: hidden;
        position: absolute;
        left: 4px;
        top: 0;
        width: 5px;
        height: 10px;
        border: solid ${ColorAddiWhite};
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
    }
`;
//# sourceMappingURL=Checkbox.styled.js.map